import { classnames } from '@src/utils/classnames';
import * as React from 'react';
import { GroupBase } from 'react-select';
import { SelectContext } from '../context';
import { IOptionBase, ISelectSingleValueProps } from '../models';
import styled from './SelectSingleValue.module.scss';
import { useMemo } from 'react';
import { getExtraStyles } from '@src/atoms/Select/utils';

export const SelectSingleValue = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>({
  selectProps,
  children,
}: React.PropsWithChildren<ISelectSingleValueProps<OptionType, GroupType, IsMulti>>) => {
  const { classNamePrefix, value, noSelectedOptions, styles } = selectProps;
  const { getValue } = React.useContext(SelectContext);
  const classes = classnames(styled.root, classNamePrefix);
  const extraStyles = useMemo(() => getExtraStyles(styles?.singleValue), [styles?.singleValue]);

  return (
    <span className={classes} data-elem="select-single-value" style={extraStyles}>
      {!noSelectedOptions && <div className={styled.rootContent}>{getValue ? getValue(value) : children}</div>}
    </span>
  );
};
